<div
  class="module-container verify-notification-container"
  *ngIf="{
    isAuthenticated: isAuthenticated$ | async,
    nVStatus: nVStatus$ | async
  } as obs"
>
  <div *ngIf="obs.nVStatus == verifyNotificationStatus.Pending" class="spinner-conatiner">
    <mat-spinner diameter="50" color="primary"></mat-spinner>
  </div>
  <div *ngIf="obs.nVStatus == verifyNotificationStatus.Success">
    <h2 translate="VERIFY_NOTIFICATION.PHONE_NUMBER.VERIFY_SUCCESS_HEADER"></h2>
    <p translate="VERIFY_NOTIFICATION.PHONE_NUMBER.PHONE_NUMBER_VERIFY_SUCCESS_DESCRIPTION"></p>
  </div>
  <div *ngIf="obs.nVStatus == verifyNotificationStatus.Error">
    <h2 translate="VERIFY_NOTIFICATION.PHONE_NUMBER.VERIFY_ERROR_HEADER"></h2>
    <p translate="VERIFY_NOTIFICATION.PHONE_NUMBER.PHONE_NUMBER_VERIFY_ERROR_DESCRIPTION"></p>
  </div>

  <button mat-raised-button color="primary" *ngIf="obs.isAuthenticated" (click)="goToHomePage()">
    <span translate="VERIFY_NOTIFICATION.PHONE_NUMBER.GO_TO_HOME_BUTTON"></span>
  </button>

  <button mat-raised-button color="primary" *ngIf="!obs.isAuthenticated" [routerLink]="login">
    <span translate="VERIFY_NOTIFICATION.PHONE_NUMBER.LOGIN_BUTTON"></span>
  </button>
</div>
